import React from 'react'

export default function PositiveLabel ({ className, text }) {
  return <div className={` ${className} w-max border rounded-xl text-[#08BD80] bg-[#DCF5ED] px-6 py-1  `}>{ text}</div>
}
